import { useState } from 'react';
import { Tag, theme, Typography } from 'antd';
import { SelectPlus } from 'Components/SelectPlus';
import { useDebounce } from '@shared/hooks/useDebounce';
import { useGetClientsFromSoftseguros } from '../hooks/useClients';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

const { Text } = Typography;

export const CREATE_CLIENT = 'createClient';

export const SelectClient = ({ mode = 'single', onSearch, ...selectProps }) => {
  const [searchText, setSearchText] = useState('');

  const { token: themeToken } = theme.useToken();

  const { data, isFetching } = useGetClientsFromSoftseguros({ searchText });

  // const records = data?.results ?? [];
  const records = data ?? [];

  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar ${isSingleMode ? 'cliente' : 'clientes'}`;

  const options = records.map((record) => ({
    value: record.id || record.softsegurosId, // Se usa cualquiera de los dos IDs
    label: <>{record.firstName} {record.lastName} <Text type='secondary'>({record.documentType} {record.documentNumber})</Text></>,
    record,
  }));

  const debouncedSetSearchText = useDebounce(setSearchText);

  const handleSearch = (newSearchText) => {
    debouncedSetSearchText(newSearchText);
    onSearch?.(newSearchText);
  };

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      loading={isFetching}
      options={[
        { // Se añade una opción para indicar la creación de un nuevo cliente
          value: CREATE_CLIENT,
          label: (<>
            <Tag
              color={themeToken.colorPrimary}
              icon={<FontAwesomeIcon icon={faUserPlus} style={{ marginRight: 5 }} />}
            >
              Nuevo
            </Tag>
            <Text italic>Crear nuevo cliente</Text>
          </>),
        },
        ...options,
      ]}
      onSearch={handleSearch}
      filterOption={false} // Se desactiva filtrado interno, ya que se maneja manualmente
      {...selectProps}
    />
  );
};